import React, { useRef, useEffect } from 'react';
import { gapi } from 'gapi-script';
import GoogleLogin from 'react-google-login';
import { useDispatch } from 'react-redux';
import { submitLoginGoogle } from 'app/auth/store/loginSlice';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  loginButton: {
    width: '250px',
    maxHeight: '46px !important',
    borderRadius: '45px !important',
    justifyContent: 'flex-start',
    gap: '15px',
    color: '#fff !important',
    backgroundColor: '#2f2f2f !important',
    padding: '3px !important',
    fontSize: '13px !important',
    fontWeight: '700 !important',
    fontFamily: 'Arial, sans-serif !important',

    '&:hover': {
      backgroundColor: '#5a5a5a !important',
      opacity: '1 !important'
    },

    '@media screen and (max-width: 959px)': {
      width: '300px',
      gap: '45px',
    },

    '& div': {
      margin: '0 !important',
      borderRadius: '50% !important'
    },

    '& span': {
      fontSize: '13px !important',
      fontWeight: '700 !important',
      fontFamily: 'Arial, sans-serif !important',
      padding: '0 20px 0 0 !important',

      '@media screen and (max-width: 959px)': {
        padding: '0 50px 0 0 !important'
      }
    }
  }
}));

const GoogleLoginButton = ({ buttonText = 'Sign in with Google' }) => {
  const classes = useStyles();
  const formRef = useRef(null);
  const clientID = '279306422463-73sh0vgq691prrt3rr0mla8t2015b1q9.apps.googleusercontent.com';
  const dispatch = useDispatch();

  useEffect(() => {
    const start = () => {
      gapi.auth2.init({
        clientId: clientID
      });
    };
    gapi.load('client:auth2', start);
  }, []);

  // Only the signed ID token is sent. The profile object sitting next to it is
  // plain client-side data, so the backend cannot trust it to say who this is.
  const onSuccess = response => {
    if (!response || !response.tokenId) {
      onFailure();
      return;
    }
    dispatch(submitLoginGoogle({ idToken: response.tokenId }));
  };

  const onFailure = () => {
    console.log('Something went wrong');
  };

  return (
    <div autoComplete="off" ref={formRef} className="flex flex-col justify-center items-center w-full text-[26px]">
      <GoogleLogin
        clientId={clientID}
        onSuccess={onSuccess}
        onFailure={onFailure}
        cookiePolicy={'single_host_policy'}
        buttonText={buttonText}
        className={clsx(classes.loginButton, 'loginButton')}
      />
    </div>
  );
};

export default GoogleLoginButton;
